import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center page-enter-active">
            <div className="relative">
                <div className="text-[10rem] md:text-[15rem] font-black gradient-text opacity-20 blur-xl absolute inset-0 flex items-center justify-center animate-pulse">
                    404
                </div>
                <div className="text-[8rem] md:text-[12rem] font-black text-gray-100 relative z-10 drop-shadow-2xl">
                    404
                </div>
            </div>
            
            <h1 className="text-3xl md:text-5xl font-bold text-gray-100 mb-6 z-10 mt-[-2rem]">
                Lost in the <span className="gradient-text">Ticket Queue?</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl z-10">
                Oops! The page you're searching for seems to have vanished or perhaps it never existed in the first place. Let's get you back to exactly where you need to be.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 z-10">
                <Link to="/" className="btn-primary py-3 px-8 text-lg group hidden sm:inline-flex">
                    Return Home
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                </Link>
                <Link to="/" className="btn-primary py-3 px-8 text-lg sm:hidden">
                    Return Home
                </Link>
                <Link to="/help" className="btn-secondary py-3 px-8 text-lg">
                    Help Center
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;
